var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "arrow",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "arrow__ellipse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 25.5,
    transform: "rotate(-90 27.5 27.5)",
    stroke: "#05F2C7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 27.5,
    r: 24.5,
    transform: "rotate(-90 26.5 27.5)",
    stroke: "#05F2C7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 24.5,
    transform: "rotate(-90 25.5 25.5)",
    stroke: "#05F2C7"
  })), /*#__PURE__*/React.createElement("g", {
    className: "arrow__polygon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 27.5L20.75 17.5407L20.75 37.4593L38 27.5Z",
    stroke: "#05F2C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 25.5L22.25 16.4067V34.5933L38 25.5Z",
    stroke: "#05F2C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 27.5L19.25 18.4067V36.5933L35 27.5Z",
    stroke: "#05F2C7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.50cc5d481833db6b20ae8a45e2d115a3.svg";
export { ForwardRef as ReactComponent };